import pickerEmojiListConcat from './pickerEmojiListConcat.json'

/**
 *
 * @param rocketName ":imp:"
 */
export const getEmojiUnifiedFromRocketName = (rocketName: string) => {
    const pickerNameForSearch = rocketName
        .replaceAll(':', '')
        .replaceAll('_', ' ')

    const emojiObj = pickerEmojiListConcat.all.find((emoji) => {
        return emoji.n.includes(pickerNameForSearch)
    })

    return emojiObj?.u
}
